import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';

import { SMALL } from '../../utils/withWidth';
import actions from '../../state/actions';
import RoomCard from './RoomCard';
import Screen from '../../components/Screen';
import TopBar from './RoomsTopBar';
import { localize } from '../../i18n';

import './Rooms.css';

class Rooms extends React.Component {
  constructor(props) {
    super(props);

    this.didProcessRequest = false;
  }

  componentWillMount() {
    this.props.addRefreshFunction((isManual) => {
      this.props.processRequest(!isManual);
    });
    if (this.didProcessRequest === false) {
      this.didProcessRequest = true;
      this.props.processRequest(false);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.didProcessRequest === false) {
      this.didProcessRequest = true;
      this.props.processRequest(false);
    }
    if (nextProps.actionType === 'API_READ' && nextProps.lastAction.configType === 'locations') {
      this.setState({
        loadingMore: false,
      });
    }
  }

  componentWillUnmount() {
    this.props.removeRefreshFunction();
  }

  render() {
    const {
      width,
      locations,
      locationsLoaded,
      totalLocations,
    } = this.props;

    let viewTypeClass = 'list_view';
    if (width > SMALL) {
      viewTypeClass = 'grid_view';
    }
    let subHeader = null;
    let roomsList = '';
    const listGridClasses = `uk-grid uk-grid-medium uk-grid-width-small-1-1 uk-grid-width-medium-1-2 uk-grid-width-large-1-2 ${viewTypeClass}`;

    if (locationsLoaded === true) {
      subHeader = (
        <h4 className="heading_a">{this.props.t('Displaying {locationsDataLength} of {totalLocations} locations.', { locationsDataLength: locations.data.length, totalLocations })}</h4>
      );
      roomsList = (
        <div className={listGridClasses}>
          {locations.data.map(loc => <RoomCard key={loc.id} loc={loc} />)}
        </div>
      );
    }

    return (
      <Screen title={this.props.t('Rooms')} helpUrl="#rooms">
        <TopBar />
        <div className="Rooms" style={{ marginTop: '88px' }}>
          {subHeader}
          {roomsList}
        </div>
      </Screen>
    );
  }
}

Rooms.propTypes = {
  // eslint-disable-next-line
  actionType: PropTypes.string,
  locations: PropTypes.shape({
    data: PropTypes.array,
  }),
  totalLocations: PropTypes.number,
  addRefreshFunction: PropTypes.func,
  removeRefreshFunction: PropTypes.func,
  processRequest: PropTypes.func,
  locationsLoaded: PropTypes.bool,
  width: PropTypes.number,
  // eslint-disable-next-line
  lastAction: PropTypes.shape(Object),
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  let nextAction = null;
  const actionType = state.action.type;
  const lastAction = state.api.lastAction;
  const locations = {
    data: [],
  };
  let totalLocations = 0;
  let locationsLoaded = false;
  const {
    routing: {
      locationBeforeTransitions: {
        pathname,
      },
    },
    layout: {
      size: width,
    },
  } = state;

  if (state.api.GemsRooms) {
    locationsLoaded = true;
    locations.data = _.sortBy(state.api.GemsRooms.data, a => parseInt(a.attributes.name, 0));
    totalLocations = locations.data.length;
  }

  if (state.filter.locations && state.filter.locations.filterKey !== 'all') {
    const type = state.filter.locations.filterKey.split(':')[0];
    const status = state.filter.locations.filterKey.split(':')[1];
    locations.data = _.filter(locations.data, a => a.attributes[type] === status);
    totalLocations = locations.data.length;
  }

  if (state.api.nextAction.locations) {
    nextAction = state.api.nextAction.locations;
  }

  return {
    locationsLoaded,
    actionType,
    locations,
    totalLocations,
    pathname,
    nextAction,
    lastAction,
    width,
  };
};

const mapDispatchToProps = dispatch => ({
  addRefreshFunction(func) {
    dispatch(actions.addRefreshFunction('rooms', func));
  },
  removeRefreshFunction() {
    dispatch(actions.removeRefreshFunction('rooms'));
  },
  processRequest(noLoader = false) {
    dispatch(actions.retrieveLocations(null, null, noLoader));
  },
  processMoreRequests() {
    dispatch(actions.retrieveMoreLocations());
  },
});

export default localize(connect(mapStateToProps, mapDispatchToProps)(Rooms));



// WEBPACK FOOTER //
// ./src/views/rooms/Rooms.js